import { BibliothequeEssencesBrowse } from '@repo/ui/features/bibliotheque/especes-browse';

export default function BibliothequeEssencesPage() {
  return <BibliothequeEssencesBrowse />;
}

